<template>
  <div class="por-title---wrapper">
    <h1
      class="por-title---heading z-u-text-display title mb-0"
      data-qa="por-title---main"
    >{{ titleText }}</h1>
    <p
      class="por-title---text subtitle"
      data-qa="por-title---text"
      v-if="text">
      {{ text }} <router-link :to="{ name: route }" data-qa="por-title---link" v-if="route && linkText" @click.native="titleLinkClick">{{ linkText }}</router-link>
    </p>
    <p v-if="$slots.default" class="por-title---extras">
      <slot></slot>
    </p>
  </div>
</template>

<script>
import { track } from '@/services/tracking'

export default {
  name: 'por-title--',
  props: {
    titleText: {
      type: String,
      required: true
    },
    text: {
      type: String
    },
    linkText: {
      type: String
    },
    route: {
      type: String
    }
  },
  methods: {
    titleLinkClick () {
      track({ name: 'button tap', params: { description: `${this.route} link` } })
    }
  }
}
</script>

<style lang="scss">
  .por-title---wrapper {
    margin-bottom: 16px;
    @media(max-width: 768px) {
      margin-bottom: 12px;
    }

    .por-title---heading.title + p {
      margin-top: 12px;
      @media(max-width: 768px) {
        margin-top: 4px;
      }
    }
  }

  .por-title---main {
    font-size: 30px;
    font-weight: $weight-semibold; // https://github.com/healthbridgeltd/ui-packages/blob/master/packages/brand-styles/assets/shared-variables/initial-variables.scss
  }

  .por-title---extras {
    margin-top: 8px;
  }
</style>
